var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Vue from "vue";
import { mapGetters } from "vuex";
import Participants from "./components/Participants";
import ChatPanel from "./components/ChatPanel";
import Local from "./components/Local";
import InfoBox from "./components/InfoBox";
import JoinPrompt from "./components/JoinPrompt";
import Spinner from "./components/Spinner";
import Stream from "./components/Stream";
import * as Screenshare from "./screenshare";
// Register Spinner globally
Vue.component("Spinner", Spinner);
export default {
    name: "app",
    components: {
        InfoBox: InfoBox,
        JoinPrompt: JoinPrompt,
        Participants: Participants,
        ChatPanel: ChatPanel,
        Local: Local,
        Stream: Stream,
    },
    watch: {
        locale: function (val) {
            this.$i18n.locale = val;
        },
    },
    computed: __assign(__assign({}, mapGetters(["chatFeatureEnabled", "sharingScreenAndVideo", "sharingScreenOnly", "screenTallyActive"])), { isError: function () {
            return !!this.$store.getters.fatalError;
        },
        isPure: function () {
            return !this.isError && this.$store.getters.appState === "pure";
        },
        isConnected: function () {
            return !this.isError && this.$store.getters.appState === "connected";
        },
        isJoining: function () {
            return !this.isError && this.$store.getters.appState === "joining";
        },
        isDisconnected: function () {
            return !this.isError && this.$store.getters.appState === "disconnected";
        },
        isIOS: function () {
            return !this.isError && this.$store.getters.appState === "ios";
        },
        /* Environment error predicates */
        isErrorNoRTC: function () {
            return this.isError && this.$store.getters.fatalError === "NO_RTC";
        },
        /* Session error predicates */
        isSessionUnknown: function () {
            return this.$store.getters.fatalError === "SESSION_UNKNOWN";
        },
        isSessionFull: function () {
            return this.$store.getters.fatalError === "SESSION_FULL";
        },
        isSessionAlreadyConnected: function () {
            return this.$store.getters.fatalError === "SESSION_ALREADYCONNECTED";
        },
        /* Minor Error */
        minorError: function () {
            return this.$store.getters.minorError;
        },
        deviceError: function () {
            return this.$store.getters.deviceError;
        },
        audioDeviceError: function () {
            return this.$store.getters.audioDeviceError;
        },
        videoDeviceError: function () {
            return this.$store.getters.videoDeviceError;
        },
        screenShareError: function () {
            return this.$store.getters.screenShareError;
        },
        /* Show chat */
        chatEnabled: function () {
            return this.isConnected && this.chatFeatureEnabled;
        } }),
    methods: {
        onMinorErrorDismiss: function () {
            this.$store.dispatch("setMinorError", false);
        },
        onShareScreenErrorDismiss: function () {
            this.$store.dispatch("setScreenShareError", null);
        },
        enableScreenshareOnly: function () {
            Screenshare.enableScreenOnly(this.$store, this.$socket);
        },
        disableScreenshareOnly: function () {
            Screenshare.stopScreen(this.$store, this.$socket);
        },
    },
    created: function () {
        if (/iphone|ipad/i.test(navigator.userAgent)) {
            this.$store.dispatch("updateAppState", "ios");
            return;
        }
        if (!window.RTCPeerConnection) {
            this.$store.dispatch("setFatalError", "NO_RTC");
        }
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
// module id = 323
// module chunks = 1